module.exports = __webpack_public_path__ + "img/hospitium-04.23b2c334.jpg";